import React from "react";

interface OwnProps {
    color: string;
}

const PaperSearchIcon = ({ color }: OwnProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M11.3334 7.99946V11.3329M8.66656 11.3329V9.99946M2 9.99946L3.88672 8.11274M5.33344 4.66602C4.80301 4.66602 4.2943 4.87673 3.91923 5.2518C3.54415 5.62687 3.33344 6.13558 3.33344 6.66602C3.33344 7.19645 3.54415 7.70516 3.91923 8.08023C4.2943 8.4553 4.80301 8.66602 5.33344 8.66602C5.86387 8.66602 6.37258 8.4553 6.74765 8.08023C7.12273 7.70516 7.33344 7.19645 7.33344 6.66602C7.33344 6.13558 7.12273 5.62687 6.74765 5.2518C6.37258 4.87673 5.86387 4.66602 5.33344 4.66602Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.33338 2H13.3334C13.5102 2 13.6797 2.07023 13.8047 2.19523C13.9297 2.32024 13.9999 2.48978 13.9999 2.66656V13.3334C13.9999 13.5102 13.9297 13.6798 13.8047 13.8048C13.6797 13.9298 13.5102 14 13.3334 14H5.33338C5.24582 14 5.15911 13.9828 5.0782 13.9494C4.9973 13.9159 4.92378 13.8668 4.86185 13.8049C4.79992 13.743 4.75079 13.6695 4.71727 13.5886C4.68376 13.5077 4.6665 13.421 4.6665 13.3334V11.3334"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PaperSearchIcon;
